import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode } from 'react';

import Utils from '../../../../../utils/immersive_utils';
import { ITableCols } from '../types';

interface StrikeReportRenderRowsProps {
  nodes: any[];
  displayedColumns: ITableCols[];
  expandedRows: string[];
  toggleRow: (id: string) => void;
  level?: number;
}

export const strikeReportRenderRows = ({
  nodes,
  displayedColumns,
  expandedRows,
  toggleRow,
  level = 0,
}: StrikeReportRenderRowsProps): JSX.Element[] => {
  const multiplierPadding = level === 0 ? 16 : 25;
  return nodes.map((node: any) => (
    <React.Fragment key={node.id}>
      <tr
        onClick={() => node.children && toggleRow(node.id)}
        className={`table-row level-${level}`}
        style={{ cursor: node.children ? 'pointer' : 'default' }}
      >
        <td
          className="sticky-col"
          style={{
            paddingLeft: `${(level + 1) * multiplierPadding}px`,
          }}
        >
          {node.children && (
            <FontAwesomeIcon
              icon={expandedRows.includes(node.id) ? faChevronUp : faChevronDown}
              className="toggle-icon"
              style={{ marginRight: 8 }}
            />
          )}
          {node.label}
        </td>

        {displayedColumns.map((col: ITableCols) => {
          const value = node.values[col.id];
          const isValueNegative = value < 0;
          const isStrikeRow = level === 0;
          const isExpiryCol = col.level === 0;

          let cellContent: ReactNode =
            value !== undefined && value !== null ? Utils.formatNumber(value, 2) : '';

          if (isStrikeRow && isExpiryCol && col.venueIcons) {
            const iconsToRender = Object.keys(col.venueIcons).filter((venueLabel) => {
              const venueKey = `${col.id}-${venueLabel}`;
              return node.values[venueKey] != null;
            });

            const venueIcons = iconsToRender.map((venueLabel: any, index: number) => (
              <img
                key={`${col.id}-${index}`}
                src={col.venueIcons![venueLabel]}
                alt={venueLabel}
                className="venue-icon"
              />
            ));
            cellContent = (
              <div className="cell-level-zero">
                {venueIcons}
                <span>{cellContent}</span>
              </div>
            );
          }

          return (
            <td
              key={`${node.id}-${col.id}`}
              className={`table-cell ${isValueNegative ? 'value-negative' : ''} column-level-${
                col.level
              }`}
            >
              {cellContent}
            </td>
          );
        })}
      </tr>
      {node.children &&
        expandedRows.includes(node.id) &&
        strikeReportRenderRows({
          nodes: node.children,
          displayedColumns,
          expandedRows,
          toggleRow,
          level: level + 1,
        })}
    </React.Fragment>
  ));
};
